import React, { Dispatch, SetStateAction } from 'react';

export const PaymentPopupContext = React.createContext<{ open: boolean; setOpen: Dispatch<SetStateAction<boolean>> }>({
  open: false,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setOpen: () => {},
});
